import { render } from "./WalletStake.vue?vue&type=template&id=251bdaa5&scoped=true"
import script from "./WalletStake.vue?vue&type=script&lang=js"
export * from "./WalletStake.vue?vue&type=script&lang=js"

import "./WalletStake.vue?vue&type=style&index=0&id=251bdaa5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bdaa5"]])

export default __exports__